/**
 * GraphQL service for AT-explore API
 */

const GRAPHQL_ENDPOINT = 'https://atexplore.social/api/graphql'

export interface GraphQLResponse<T> {
    data?: T
    errors?: GraphQLError[]
}

export interface GraphQLError {
    message: string
    path?: string[]
    extensions?: Record<string, unknown>
}

/**
 * Execute a GraphQL query
 */
export async function graphqlQuery<T>(
    query: string,
    variables?: Record<string, unknown>
): Promise<GraphQLResponse<T>> {
    const response = await fetch(GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query, variables }),
    })

    if (!response.ok) {
        throw new Error(`GraphQL request failed: ${response.status}`)
    }

    return response.json()
}
